/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import React, { useState } from "react";
import { useCallback } from "react";
import { Env } from "../../controller/constant";
import GSheetContext from "./gSheetContext";

import { getLoggedUserInfo } from '../../basetool/methods'
import { WtLoginKey } from '../../constants/loginKeys'

const GSheetState = (props) => {
  // Loader Handling
  const [isLoading, setIsLoading] = useState(undefined);
  const [isSelectTemplate, setIsSelectTemplate] = useState(false);

  const [getResponseData, setresponseData] = React.useState([])
  const [templateData, setTemplateData] = useState();
  const handleWTLoader = (val) => setIsLoading(val);
  // End of Loader Handling

  var firesocketBusinessId = getLoggedUserInfo(WtLoginKey.businessId)



  const googleSheetData = useCallback((val) => {
    setIsSelectTemplate(true)
    setTemplateData(val)
    console.log("gSheetTemplateData", val);
  }, []);

  const updateuserGSheetData = useCallback(async (val) => {
    const response = await axios.post(Env.baseApiCallURL + "/app/gsheet/integration", val, {})
    console.log("G-Sheet Response", response)

  }, [])



  function setCookie(cName, cValue, expDays) {
    let date = new Date();
    date.setTime(date.getTime() + expDays * 24 * 60 * 60 * 1000);
    const expires = "expires=" + date.toUTCString();
    document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
  }

  const googleSheetGetData = useCallback(async () => {
    const response = await axios.get(Env.baseApiCallURL + "/app/gsheet/data/" + firesocketBusinessId)
    console.log("response :", response)
    setresponseData(response)
  }, [])

  return (
    <GSheetContext.Provider
      value={{
        isLoading,
        handleWTLoader,
        googleSheetData,
        isSelectTemplate,
        templateData,
        updateuserGSheetData,
        googleSheetGetData,
        getResponseData,
        setCookie
      }}
    >
      {props.children}
    </GSheetContext.Provider>
  );
};
export default GSheetState;
